// PDF import
import { useParams, Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
// CSS removed for Tailwind migration
import {
  FaMapMarkerAlt,
  FaBed,
  FaBath,
  FaRuler,
  FaPhone,
  FaEnvelope,
  FaArrowLeft,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaLayerGroup,
  FaCity,
  FaStar,
  FaCouch,
  FaVihara,
  FaCrown,
  FaSwimmingPool,
  FaDumbbell,
  FaUmbrellaBeach,
  FaUtensils,
  FaDice,
  FaCar,
  FaShieldAlt,
  FaChild,
  FaSpa,
  FaShoppingBag,
  FaBuilding,
  FaHome,
  FaMoneyBillWave,
  FaHandHoldingUsd,
  FaChartLine,
  FaKey,
  FaCalendarAlt,
  FaFilePdf,
  FaDownload,
  FaExternalLinkAlt
} from 'react-icons/fa';
import { propertyData } from './propertyData';
import { getMultiCurrencyPrice } from './currencyUtils';


// Icon mapping
const iconMap = {
  FaSwimmingPool: <FaSwimmingPool />,
  FaDumbbell: <FaDumbbell />,
  FaUmbrellaBeach: <FaUmbrellaBeach />,
  FaUtensils: <FaUtensils />,
  FaDice: <FaDice />,
  FaCar: <FaCar />,
  FaShieldAlt: <FaShieldAlt />,
  FaChild: <FaChild />,
  FaSpa: <FaSpa />,
  FaShoppingBag: <FaShoppingBag />,
  FaHome: <FaHome />,
  FaBuilding: <FaBuilding />,
  FaStar: <FaStar />,
  FaCity: <FaCity />,
  FaCouch: <FaCouch />,
  FaVihara: <FaVihara />,
  FaCrown: <FaCrown />
};


// PDF Brochure configuration for properties
const propertyBrochures = {
  'the-hillgate-dubai-silicon-oasis': [
    "/assets/plan2-img1.jpg",
    "/assets/plan2-img2.jpg",
    "/assets/plan2-img3.jpg",
    "/assets/plan2-img4.jpg",
    "/assets/plan2-img5.jpg",
    "/assets/plan2-img6.jpg",
    "/assets/plan2-img7.jpg",
    "/assets/plan2-img8.jpg",
    "/assets/plan2-img9.jpg",
    "/assets/plan2-img10.jpg",
    "/assets/plan2-img11.jpg",
    "/assets/plan2-img12.jpg",
    "/assets/plan2-img13.jpg"
  ],
  'portside-square-mina-rashid': [
    "/assets/plan3-img1.jpg"
  ],
  'v-suites-business-bay': [
    "/assets/plan4-img1.jpg",
    "/assets/plan4-img2.jpg",
    "/assets/plan4-img3.jpg",
    "/assets/plan4-img4.jpg"
  ],
  'symphony-meydan-horizon': [
    "/assets/symphony/plan1.jpg",
    "/assets/symphony/plan2.jpg",
    "/assets/symphony/plan3.jpg",
    "/assets/symphony/plan4.jpg",
    "/assets/symphony/plan5.jpg",
    "/assets/symphony/plan6.jpg",
    "/assets/symphony/plan7.jpg",
    "/assets/symphony/plan8.jpg",
    "/assets/symphony/plan9.jpg",
    "/assets/symphony/plan10.jpg",
    "/assets/symphony/plan11.jpg",
    "/assets/symphony/plan12.jpg",
    "/assets/symphony/plan13.jpg",
    "/assets/symphony/plan14.jpg",
    "/assets/symphony/plan15.jpg",
    "/assets/symphony/plan16.jpg",
    "/assets/symphony/plan17.jpg",
    "/assets/symphony/plan18.jpg",
    "/assets/symphony/plan19.jpg",
    "/assets/symphony/plan20.jpg",
    "/assets/symphony/plan21.jpg",
    "/assets/symphony/plan22.jpg",
    "/assets/symphony/plan23.jpg",
    "/assets/symphony/plan24.jpg",
    "/assets/symphony/plan25.jpg",
    "/assets/symphony/plan26.jpg",
    "/assets/symphony/plan27.jpg",
    "/assets/symphony/plan28.jpg",
    "/assets/symphony/plan29.jpg",
    "/assets/symphony/plan30.jpg",
    "/assets/symphony/plan31.jpg",
    "/assets/symphony/plan32.jpg",
    "/assets/symphony/plan33.jpg",
    "/assets/symphony/plan34.jpg",
    "/assets/symphony/plan35.jpg"
  ],
  'azizi-riviera': [
    "/assets/plan5-img1.jpg",
    "/assets/plan5-img2.jpg",
    "/assets/plan6-img1.jpg",
    "/assets/plan6-img2.jpg"
  ],
  'tonino-lamborghini-al-marjan': [
    "/assets/plan7-img1.jpg",
    "/assets/plan7-img2.jpg",
    "/assets/plan7-img3.jpg",
    "/assets/plan7-img4.jpg",
    "/assets/plan7-img5.jpg",
    "/assets/plan7-img6.jpg",
    "/assets/plan7-img7.jpg",
    "/assets/plan7-img8.jpg",
    "/assets/plan7-img9.jpg",
    "/assets/plan7-img10.jpg",
    "/assets/plan7-img11.jpg",
    "/assets/plan7-img12.jpg"
  ],
  'taj-wellington-mews-al-marjan': [
    "/assets/plan8-img1.jpg",
    "/assets/plan8-img2.jpg"
  ],
  'ramada-residences-al-jaddaf': [
    "/assets/plan9-img1.jpg",
    "/assets/plan9-img2.jpg",
    "/assets/plan9-img3.jpg",
    "/assets/plan9-img4.jpg",
    "/assets/plan9-img5.jpg",
    "/assets/plan9-img6.jpg"
  ],
  'pelagia-al-marjan': [
    "/assets/plan10-img1.jpg",
    "/assets/plan10-img2.jpg",
    "/assets/plan10-img3.jpg",
    "/assets/plan10-img4.jpg"
  ],
  'la-perla-al-marjan': [
    "/assets/plan11-img1.jpg",
    "/assets/plan11-img2.jpg",
    "/assets/plan11-img3.jpg"
  ],
  'fashion-tv-acacia-al-marjan': [
    "/assets/plan12-img1.jpg",
    "/assets/plan12-img2.jpg",
    "/assets/plan12-img3.jpg"
  ],
  'aqua-arc-al-marjan': [
    "/assets/plan13-img1.jpg",
    "/assets/plan14-img1.jpg",
    "/assets/plan14-img2.jpg",
    "/assets/plan14-img3.jpg",
    "/assets/plan14-img4.jpg"
  ],
  'belgravia-gardens-dubailand': {
    type: 'pdf',
    src: '/assets/belgravia/brochure.pdf'
  },
  'ocean-house-palm-jumeirah': {
    type: 'pdf',
    src: '/assets/ocean-house/brochure.pdf'
  },
  'playa-del-sol-ras-al-khaimah': {
    type: 'pdf',
    src: '/assets/playa-del-sol/brochure.pdf'
  },
  'costa-mare-al-marjan': {
    type: 'pdf',
    src: '/assets/costa-mare/brochure.pdf'
  },
  'eltiera-views-jumeirah-islands': {
    type: 'pdf',
    src: '/assets/eltiera-views/brochure.pdf'
  },
  'mercer-house-uptown-dubai': {
    type: 'pdf',
    src: '/assets/mercer-house/brochure.pdf'
  },
  'the-quayside-business-bay': {
    type: 'pdf',
    src: '/assets/the-quayside/brochure.pdf'
  },
  'green-ville-emaar': {
    type: 'pdf',
    src: '/assets/green-ville/brochure.pdf'
  },
  'bluewaters-residences-meraas': {
    type: 'pdf',
    src: '/assets/bluewaters-residences/brochure.pdf'
  },
  'bay-grove-nakheel': {
    type: 'pdf',
    src: '/assets/bay-grove/brochure.pdf'
  },
  'palm-jebel-ali-nakheel': {
    type: 'pdf',
    src: '/assets/palm-jebel-ali/brochure.pdf'
  },
  'como-residences-nakheel': {
    type: 'pdf',
    src: '/assets/como-residences/brochure.pdf'
  },
  'rixos-residences-nakheel': {
    type: 'pdf',
    src: '/assets/rixos-residences/brochure.pdf'
  },
  'palm-beach-towers-nakheel': {
    type: 'pdf',
    src: '/assets/palm-beach-towers/brochure.pdf'
  },
  'binghatti-skyrise-business-bay': {
    type: 'pdf',
    src: '/assets/binghatti-skyrise/1.pdf'
  },
  'danube-elitz-3-al-furjan': {
    type: 'pdf',
    src: '/assets/danube-elitz-3/1.pdf'
  },
  'peace-homes-town-square': {
    type: 'pdf',
    src: '/assets/peace-homes/1.pdf'
  },
  'samana-park-views-arjan': {
    type: 'pdf',
    src: '/assets/samana-park-views/1.pdf'
  },
  'damac-lagoons-damac-hills': {
    type: 'pdf',
    src: '/assets/damac-lagoons/1.pdf'
  },
  'deyaar-midtown-dubai-production-city': {
    type: 'pdf',
    src: '/assets/deyaar-midtown/1.pdf'
  },
  'majid-al-futtaim-tilal-al-ghaf': {
    type: 'pdf',
    src: '/assets/majid-al-futtaim-tilal-al-ghaf/1.pdf'
  },
  'tiger-group-dubai-hills': {
    type: 'pdf',
    src: '/assets/tiger-group-dubai-hills/1.pdf'
  },

  'one-river-point-business-bay': {
    type: 'pdf-multi',
    files: [
      {
        name: 'One River Point',
        src: '/assets/oneriver/floor-plans.pdf'
      },
      {
        name: 'The Crestmark',
        src: '/assets/oneriver/overview.pdf'
      }
    ]
  }
};


export default function PropertyDetail() {
  const { slug } = useParams();
  const [mainImage, setMainImage] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [currentPdfPage, setCurrentPdfPage] = useState(0);
  const [pdfTouchStart, setPdfTouchStart] = useState(0);
  const [pdfTouchEnd, setPdfTouchEnd] = useState(0);

  const mainVideoRef = useRef(null);
  const lightboxVideoRef = useRef(null);

  const property = propertyData[slug] || propertyData['tonino-lamborghini-al-marjan'];
  const brochureData = propertyBrochures[slug] || null;

  // Check brochure type
  const isSinglePdf = brochureData && brochureData.type === 'pdf';
  const isMultiPdf = brochureData && brochureData.type === 'pdf-multi';
  const isImagePages = brochureData && Array.isArray(brochureData);

  const pdfFile = isSinglePdf ? brochureData.src : null;
  const pdfFiles = isMultiPdf ? brochureData.files : null;
  const pdfPages = isImagePages ? brochureData : null;

  const hasMediaArray = property.media && Array.isArray(property.media);
  const mediaItems = hasMediaArray ? property.media : (property.images || []).map(img => ({ type: 'image', src: img }));

  useEffect(() => {
    console.log('===== DEBUG INFO =====');
    console.log('Current slug:', slug);
    console.log('Brochure Data:', brochureData);
    console.log('Is Single PDF:', isSinglePdf);
    console.log('Is Multi PDF:', isMultiPdf);
    console.log('Is Image Pages:', isImagePages);
    console.log('PDF File:', pdfFile);
    console.log('PDF Files:', pdfFiles);
    console.log('PDF Pages:', pdfPages);
    console.log('====================');
  }, [slug, brochureData, isSinglePdf, isMultiPdf, isImagePages, pdfFile, pdfFiles, pdfPages]);

  useEffect(() => {
    if (mainVideoRef.current && mediaItems[mainImage]?.type === 'video') {
      const playPromise = mainVideoRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => console.log('✅ Main video autoplay successful!'))
          .catch(error => console.error('❌ Main video autoplay prevented:', error));
      }
    }
  }, [mainImage, mediaItems]);

  useEffect(() => {
    if (lightboxOpen && lightboxVideoRef.current && mediaItems[lightboxImage]?.type === 'video') {
      const playPromise = lightboxVideoRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => console.log('✅ Lightbox video autoplay successful!'))
          .catch(error => console.error('❌ Lightbox video autoplay prevented:', error));
      }
    }
  }, [lightboxOpen, lightboxImage, mediaItems]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [slug]);

  const handleLocationClick = () => {
    if (property.mapUrl) {
      window.open(property.mapUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const openLightbox = (index) => {
    setLightboxImage(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  };

  const nextImage = () => {
    setLightboxImage((prev) => (prev + 1) % mediaItems.length);
  };

  const prevImage = () => {
    setLightboxImage((prev) => (prev - 1 + mediaItems.length) % mediaItems.length);
  };

  const handleThumbnailClick = (index) => {
    setMainImage(index);
    openLightbox(index);
  };

  const handleMainImageClick = () => {
    openLightbox(mainImage);
  };

  const openPdfViewer = () => {
    setCurrentPdfPage(0);
    setPdfViewerOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closePdfViewer = () => {
    setPdfViewerOpen(false);
    document.body.style.overflow = 'auto';
  };

  const nextPdfPage = () => {
    if (pdfPages) {
      setCurrentPdfPage((prev) => (prev + 1) % pdfPages.length);
    }
  };

  const prevPdfPage = () => {
    if (pdfPages) {
      setCurrentPdfPage((prev) => (prev - 1 + pdfPages.length) % pdfPages.length);
    }
  };

  const handlePdfTouchStart = (e) => {
    setPdfTouchStart(e.targetTouches[0].clientX);
  };

  const handlePdfTouchMove = (e) => {
    setPdfTouchEnd(e.targetTouches[0].clientX);
  };

  const handlePdfTouchEnd = () => {
    if (!pdfTouchStart || !pdfTouchEnd) return;
    const distance = pdfTouchStart - pdfTouchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    if (isLeftSwipe) nextPdfPage();
    if (isRightSwipe) prevPdfPage();
    setPdfTouchStart(0);
    setPdfTouchEnd(0);
  };

  const handleOpenPdf = () => {
    if (pdfFile) {
      window.open(pdfFile, '_blank', 'noopener,noreferrer');
    }
  };

  const handleDownloadPdf = () => {
    if (pdfFile) {
      const link = document.createElement('a');
      link.href = pdfFile;
      link.download = `${property.title.replace(/\s+/g, '-')}-Brochure.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (lightboxOpen) {
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') nextImage();
        if (e.key === 'ArrowLeft') prevImage();
      }
      if (pdfViewerOpen && isImagePages) {
        if (e.key === 'Escape') closePdfViewer();
        if (e.key === 'ArrowRight') nextPdfPage();
        if (e.key === 'ArrowLeft') prevPdfPage();
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [lightboxOpen, pdfViewerOpen, isImagePages]);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    if (isLeftSwipe) nextImage();
    if (isRightSwipe) prevImage();
    setTouchStart(0);
    setTouchEnd(0);
  };

  useEffect(() => {
    setMainImage(0);
  }, [slug]);

  const handleVideoCanPlay = () => {
    console.log('✅ Video can play - ready to start');
  };

  const handleVideoLoadedMetadata = () => {
    console.log('✅ Video metadata loaded');
  };

  const handleVideoError = (e) => {
    console.error('❌ Video loading error:', e);
    console.error('Error code:', e.target.error?.code);
    console.error('Error message:', e.target.error?.message);
    console.error('Video src:', e.target.src);
  };

  const renderPricing = () => {
    if (property.multiUnitPricing) {
      return (
        <div className="mb-10 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <h2 className="font-display text-2xl text-[#0a0a0a] mb-6 uppercase tracking-wider border-b border-gray-200 pb-2">Pricing Options</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {property.multiUnitPricing.map((unit, index) => {
              const prices = getMultiCurrencyPrice(unit.aed);
              const isPremium = index === property.multiUnitPricing.length - 1 && property.multiUnitPricing.length > 2;
              return (
                <div key={index} className={`relative p-6 bg-white rounded-2xl border transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${isPremium ? 'border-[#c8a45e] shadow-gold-sm bg-gradient-to-br from-white to-[#f9f4e8]' : 'border-gray-100 shadow-sm hover:border-[#c8a45e]/30'}`}>
                  {isPremium && (
                    <div className="absolute top-0 right-0 bg-[#c8a45e] text-white text-[10px] uppercase font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg">
                      Premium
                    </div>
                  )}
                  <div className="text-3xl text-[#c8a45e] mb-4">
                    {unit.icon ? iconMap[unit.icon] || <FaHome /> : <FaHome />}
                  </div>
                  <h3 className="font-display text-lg font-bold text-[#0a0a0a] mb-2">{unit.type}</h3>
                  <p className="font-display text-xl text-[#0a0a0a] font-bold mb-1">{prices.combined}</p>
                  <p className="text-sm text-gray-500 mb-2">{unit.label}</p>
                  {unit.usdPrice && <p className="text-xs text-[#c8a45e] font-semibold">USD {unit.usdPrice}</p>}
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    if (property.pricing) {
      const apartments = getMultiCurrencyPrice(property.pricing.apartments.aed);
      const villas = getMultiCurrencyPrice(property.pricing.villas.aed);
      const mansions = getMultiCurrencyPrice(property.pricing.mansions.aed);
      return (
        <div className="mb-10 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <h2 className="font-display text-2xl text-[#0a0a0a] mb-6 uppercase tracking-wider border-b border-gray-200 pb-2">Pricing Options</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#c8a45e]/30 group">
              <FaHome className="text-3xl text-[#c8a45e] mb-4 transition-transform group-hover:scale-110" />
              <h3 className="font-display text-lg font-bold text-[#0a0a0a] mb-2">Sea Front Apartments</h3>
              <p className="font-display text-xl text-[#0a0a0a] font-bold mb-1">{apartments.combined}</p>
              <p className="text-sm text-gray-500">{property.pricing.apartments.label}</p>
            </div>
            <div className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#c8a45e]/30 group">
              <FaVihara className="text-3xl text-[#c8a45e] mb-4 transition-transform group-hover:scale-110" />
              <h3 className="font-display text-lg font-bold text-[#0a0a0a] mb-2">Luxury Villas</h3>
              <p className="font-display text-xl text-[#0a0a0a] font-bold mb-1">{villas.combined}</p>
              <p className="text-sm text-gray-500">{property.pricing.villas.label}</p>
            </div>
            <div className="relative p-6 bg-gradient-to-br from-white to-[#fcfcfc] rounded-2xl border border-[#c8a45e] shadow-gold-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-gold group">
              <div className="absolute top-0 right-0 bg-[#c8a45e] text-white text-[10px] uppercase font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg">Exlcusive</div>
              <FaCrown className="text-3xl text-[#c8a45e] mb-4 transition-transform group-hover:scale-110" />
              <h3 className="font-display text-lg font-bold text-[#0a0a0a] mb-2">Ultra Luxury Mansions</h3>
              <p className="font-display text-xl text-[#0a0a0a] font-bold mb-1">{mansions.combined}</p>
              <p className="text-sm text-gray-500">{property.pricing.mansions.label}</p>
            </div>
          </div>
        </div>
      );
    }

    if (property.ellingtonPricing) {
      const prices = getMultiCurrencyPrice(property.ellingtonPricing.startingPrice.aed);
      return (
        <div className="mb-10 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <h2 className="font-display text-2xl text-[#0a0a0a] mb-6 uppercase tracking-wider border-b border-gray-200 pb-2">Pricing & Payment Plan</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#c8a45e]/30 group">
              <FaMoneyBillWave className="text-3xl text-[#c8a45e] mb-4 transition-transform group-hover:scale-110" />
              <h3 className="font-display text-lg font-bold text-[#0a0a0a] mb-2">Starting Price</h3>
              <p className="font-display text-xl text-[#0a0a0a] font-bold mb-1">{prices.combined}</p>
              <p className="text-sm text-gray-500">Competitive pricing for investors</p>
            </div>
            <div className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#c8a45e]/30 group">
              <FaHandHoldingUsd className="text-3xl text-[#c8a45e] mb-4 transition-transform group-hover:scale-110" />
              <h3 className="font-display text-lg font-bold text-[#0a0a0a] mb-2">Payment Plan</h3>
              <p className="font-display text-xl text-[#0a0a0a] font-bold mb-1">{property.ellingtonPricing.paymentPlan}</p>
              <p className="text-sm text-gray-500">Flexible payment options available</p>
            </div>
            <div className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#c8a45e]/30 group">
              <FaStar className="text-3xl text-[#c8a45e] mb-4 transition-transform group-hover:scale-110" />
              <h3 className="font-display text-lg font-bold text-[#0a0a0a] mb-2">Investment Highlight</h3>
              <p className="font-display text-xl text-[#0a0a0a] font-bold mb-1">High ROI</p>
              <p className="text-sm text-gray-500">{property.ellingtonPricing.highlights}</p>
            </div>
          </div>
          <div className="text-center">
            <Link to="/contact" className="inline-flex items-center justify-center px-10 py-4 bg-[#0a0a0a] text-white rounded-full font-display text-sm uppercase tracking-wider hover:bg-[#c8a45e] hover:text-[#0a0a0a] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
              Enquire Now
            </Link>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <section className="relative pt-28 pb-20 bg-[#fafafa] min-h-screen">
        {/* Top accent line */}
        <div className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c8a45e] to-transparent z-50"></div>

        <div className="container mx-auto px-4 max-w-7xl">
          {/* Back Button */}
          <Link to="/properties/residential" className="inline-flex items-center gap-2 group mb-8">
            <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center group-hover:border-[#c8a45e] group-hover:bg-[#c8a45e] transition-all duration-300 shadow-sm">
              <FaArrowLeft className="text-gray-600 group-hover:text-white text-sm transition-colors" />
            </div>
            <span className="font-display text-sm font-bold uppercase tracking-wider text-gray-500 group-hover:text-[#0a0a0a] transition-colors">Back to Properties</span>
          </Link>

          {property.isFeatured && (
            <div className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#c8a45e] to-[#d4a746] text-white rounded-full text-xs font-bold uppercase tracking-wider shadow-lg animate-pulse">
              <FaStar className="text-sm" />
              <span>Featured Property - Pre-Launch Prices Available</span>
            </div>
          )}

          {/* Image Gallery */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-12">
            {/* Main Image */}
            <div className="lg:col-span-8 relative group rounded-2xl overflow-hidden shadow-2xl h-[50vh] lg:h-[600px] bg-gray-100 cursor-pointer" onClick={handleMainImageClick}>
              {mediaItems[mainImage]?.type === 'video' ? (
                <video
                  ref={mainVideoRef}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="auto"
                  poster={mediaItems[mainImage].poster}
                  onCanPlay={handleVideoCanPlay}
                  onLoadedMetadata={handleVideoLoadedMetadata}
                  onError={handleVideoError}
                >
                  <source src={mediaItems[mainImage].src} type="video/mp4" />
                  <source src={mediaItems[mainImage].src} type="video/webm" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={mediaItems[mainImage]?.src}
                  alt={property.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  onError={(e) => console.error('Image error:', e)}
                />
              )}
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
              <div className="absolute bottom-6 right-6 bg-white/90 backdrop-blur-md px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-wider text-[#0a0a0a] shadow-lg flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                <span>{mediaItems[mainImage]?.type === 'video' ? 'Click to Play Fullscreen' : 'Click to Zoom'}</span>
                <FaExternalLinkAlt />
              </div>
            </div>

            {/* Thumbnails Sidebar - Desktop */}
            <div className="hidden lg:flex lg:col-span-4 flex-col gap-4 h-[600px] overflow-y-auto pr-2 custom-scrollbar">
              {mediaItems.map((item, index) => (
                <div
                  key={index}
                  className={`w-full h-32 rounded-xl overflow-hidden cursor-pointer relative flex-shrink-0 border-2 transition-all duration-300 ${mainImage === index ? 'border-[#c8a45e] shadow-md' : 'border-transparent opacity-70 hover:opacity-100'}`}
                  onClick={() => handleThumbnailClick(index)}
                >
                  {item.type === 'video' ? (
                    <div className="relative w-full h-full bg-black">
                      <video src={item.src} className="w-full h-full object-cover opacity-80" muted />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                          <div className="w-0 h-0 border-t-[5px] border-t-transparent border-l-[8px] border-l-white border-b-[5px] border-b-transparent ml-1"></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <img
                      src={item.src}
                      alt={`View ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  )}
                  {mainImage === index && <div className="absolute inset-0 bg-[#c8a45e]/10 pointer-events-none"></div>}
                </div>
              ))}
            </div>

            {/* Thumbnails Row - Mobile */}
            <div className="lg:hidden flex gap-3 overflow-x-auto pb-4 custom-scrollbar snap-x">
              {mediaItems.map((item, index) => (
                <div
                  key={index}
                  className={`w-28 h-20 rounded-lg overflow-hidden cursor-pointer flex-shrink-0 snap-start border-2 transition-all ${mainImage === index ? 'border-[#c8a45e]' : 'border-transparent opacity-80'}`}
                  onClick={() => handleThumbnailClick(index)}
                >
                  <img src={item.type === 'video' ? item.poster || item.src : item.src} className="w-full h-full object-cover" alt="" />
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            {/* Main Content Info */}
            <div className="lg:col-span-8">
              <div className="mb-8">
                <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#0a0a0a] mb-4 leading-tight">{property.title}</h1>
                <div
                  className={`inline-flex items-center gap-2 text-gray-500 font-medium ${property.mapUrl ? 'cursor-pointer hover:text-[#c8a45e] transition-colors' : ''}`}
                  onClick={property.mapUrl ? handleLocationClick : undefined}
                >
                  <FaMapMarkerAlt className="text-[#c8a45e]" />
                  <span>{property.location}</span>
                </div>
              </div>

              {/* Quick Stats Grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-6 bg-white rounded-2xl border border-gray-100 shadow-sm mb-10">
                {[
                  { icon: FaBed, val: property.bedrooms, label: 'Bedrooms' },
                  { icon: FaBath, val: property.bathrooms, label: 'Bathrooms' },
                  { icon: FaRuler, val: property.area, label: 'Units' }, // Area might be sqft or units
                  { icon: FaLayerGroup, val: property.floors, label: 'Floor' },
                ].map((stat, i) => (
                  <div key={i} className="flex flex-col items-center justify-center text-center p-2">
                    <stat.icon className="text-2xl text-[#c8a45e] mb-2" />
                    <span className="font-display text-lg font-bold text-[#0a0a0a]">{stat.val}</span>
                    <span className="text-xs text-gray-400 uppercase tracking-widest">{stat.label}</span>
                  </div>
                ))}
              </div>

              <div className="prose prose-lg max-w-none text-gray-600 mb-12 leading-relaxed">
                <h2 className="font-display text-2xl text-[#0a0a0a] mb-4 not-prose uppercase tracking-wider border-b border-gray-200 pb-2">About Property</h2>
                <p className="whitespace-pre-line">{property.description}</p>
              </div>

              {renderPricing()}

              {property.specialFeatures && (
                <div className="mb-12">
                  <h2 className="font-display text-2xl text-[#0a0a0a] mb-6 uppercase tracking-wider border-b border-gray-200 pb-2">Special Highlights</h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {property.specialFeatures.map((feature, index) => (
                      <div key={index} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100 hover:border-[#c8a45e]/30 transition-colors">
                        <div className="w-6 h-6 rounded-full bg-[#c8a45e]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <FaStar className="text-xs text-[#c8a45e]" />
                        </div>
                        <span className="text-gray-700 font-medium">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="mb-12">
                <h2 className="font-display text-2xl text-[#0a0a0a] mb-6 uppercase tracking-wider border-b border-gray-200 pb-2">Property Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 bg-white p-8 rounded-2xl border border-gray-100 shadow-sm">
                  {[
                    { label: 'Property Type', val: property.type },
                    { label: 'Builder', val: property.builder },
                    { label: 'Category', val: property.category },
                    { label: 'Floor', val: property.floors },
                  ].map((detail, i) => (
                    <div key={i} className="flex justify-between items-center py-3 border-b border-dashed border-gray-200 last:border-0">
                      <span className="text-gray-500 font-medium">{detail.label}</span>
                      <span className="font-display text-[#0a0a0a] font-bold">{detail.val}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mb-12">
                <h2 className="font-display text-2xl text-[#0a0a0a] mb-6 uppercase tracking-wider border-b border-gray-200 pb-2">Key Features & Amenities</h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                  {property.features.map((feature, index) => (
                    <div key={index} className="flex flex-col items-center justify-center p-6 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 text-center group">
                      <div className="text-3xl text-[#c8a45e] mb-3 transition-transform group-hover:scale-110">
                        {iconMap[feature.icon]}
                      </div>
                      <span className="text-sm font-semibold text-gray-700">{feature.text}</span>
                    </div>
                  ))}
                </div>
              </div>

              {property.investmentInfo && (
                <div className="mb-12">
                  <h2 className="font-display text-2xl text-[#0a0a0a] mb-6 uppercase tracking-wider border-b border-gray-200 pb-2">Investment Information</h2>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {property.investmentInfo.roi && (
                      <div className="p-6 bg-gradient-to-br from-[#0a0a0a] to-[#1a1a1a] text-white rounded-2xl shadow-lg relative overflow-hidden group">
                        <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-150 transition-transform duration-700"></div>
                        <FaChartLine className="text-3xl text-[#c8a45e] mb-4" />
                        <h4 className="font-display text-lg font-bold mb-1 opacity-80">Expected ROI</h4>
                        <p className="font-display text-2xl font-bold text-[#c8a45e]">{property.investmentInfo.roi}</p>
                      </div>
                    )}
                    {property.investmentInfo.handover && (
                      <div className="p-6 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-all group">
                        <FaCalendarAlt className="text-3xl text-[#c8a45e] mb-4 transition-transform group-hover:scale-110" />
                        <h4 className="font-display text-lg font-bold text-[#0a0a0a] mb-1">Handover Date</h4>
                        <p className="text-gray-600 font-medium">{property.investmentInfo.handover}</p>
                      </div>
                    )}
                    {property.investmentInfo.rentalYield && (
                      <div className="p-6 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-all group">
                        <FaKey className="text-3xl text-[#c8a45e] mb-4 transition-transform group-hover:scale-110" />
                        <h4 className="font-display text-lg font-bold text-[#0a0a0a] mb-1">Rental Yield</h4>
                        <p className="text-gray-600 font-medium">{property.investmentInfo.rentalYield}</p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Sidebar Sticky */}
            <div className="lg:col-span-4 relative">
              <div className="lg:sticky lg:top-32 flex flex-col gap-6">

                {/* Price Card */}
                <div className="bg-[#0a0a0a] text-white p-8 rounded-2xl shadow-2xl relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-40 h-40 bg-[#c8a45e] opacity-10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
                  <h3 className="font-display text-xl font-bold mb-2 uppercase tracking-wide text-white/90">
                    {property.pricing || property.ellingtonPricing || property.multiUnitPricing ? 'Starting Prices' : 'Price on Request'}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4 border-b border-gray-800 pb-4">
                    {property.pricing || property.ellingtonPricing || property.multiUnitPricing ? 'Prices shown in AED / INR' : 'Contact for pricing details'}
                  </p>

                  {property.isFeatured && (
                    <div className="mb-6 bg-[#c8a45e]/20 border border-[#c8a45e]/30 rounded-lg p-3 flex items-start gap-3">
                      <FaDice className="text-[#c8a45e] text-lg mt-0.5" />
                      <div>
                        <p className="text-[#c8a45e] font-bold text-sm uppercase tracking-wider">Limited Time Offer</p>
                        <p className="text-gray-300 text-xs">Pre-Launch prices ending soon</p>
                      </div>
                    </div>
                  )}

                  <Link to="/contact" className="w-full block text-center py-4 bg-[#c8a45e] text-[#0a0a0a] font-display font-bold uppercase tracking-widest rounded-full hover:bg-white transition-all duration-300 shadow-lg hover:shadow-white/20 transform hover:-translate-y-1">
                    Request Call Back
                  </Link>
                </div>

                {/* Brochure Card */}
                {brochureData && (
                  <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-lg">
                    <h3 className="font-display text-lg font-bold text-[#0a0a0a] mb-2 uppercase tracking-wide">Property Brochure</h3>
                    <p className="text-gray-500 text-sm mb-6">View detailed floor plans and specifications</p>

                    {isMultiPdf ? (
                      <div className="space-y-3">
                        {pdfFiles.map((file, index) => (
                          <div key={index} className="flex gap-2">
                            <button
                              onClick={() => window.open(file.src, '_blank', 'noopener,noreferrer')}
                              className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-[#0a0a0a] rounded-xl font-bold text-xs uppercase tracking-wide transition-all"
                            >
                              <FaExternalLinkAlt /> {file.name}
                            </button>
                            <button
                              onClick={() => {
                                const link = document.createElement('a');
                                link.href = file.src;
                                link.download = `${property.title.replace(/\s+/g, '-')}-${file.name.replace(/\s+/g, '-')}.pdf`;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }}
                              className="w-12 inline-flex items-center justify-center bg-gray-100 hover:bg-[#c8a45e] hover:text-[#0a0a0a] rounded-xl transition-all"
                              title="Download PDF"
                            >
                              <FaDownload />
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : isSinglePdf ? (
                      <div className="flex gap-3">
                        <button onClick={handleOpenPdf} className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-[#0a0a0a] text-white hover:bg-[#333] rounded-xl font-bold text-xs uppercase tracking-wide transition-all shadow-md hover:shadow-lg">
                          <FaExternalLinkAlt /> View PDF
                        </button>
                        <button onClick={handleDownloadPdf} className="w-12 inline-flex items-center justify-center bg-gray-100 hover:bg-[#c8a45e] hover:text-[#0a0a0a] rounded-xl transition-all border border-gray-200">
                          <FaDownload />
                        </button>
                      </div>
                    ) : isImagePages ? (
                      <button onClick={openPdfViewer} className="w-full inline-flex items-center justify-center gap-2 px-4 py-4 bg-[#0a0a0a] text-white hover:bg-[#333] rounded-xl font-bold text-xs uppercase tracking-wide transition-all shadow-md hover:shadow-lg group">
                        <FaFilePdf className="text-[#c8a45e] group-hover:text-white transition-colors" />
                        View Brochure ({pdfPages.length} Pages)
                      </button>
                    ) : null}
                  </div>
                )}

                {/* Agent Contact Card */}
                <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-lg relative overflow-hidden">
                  <div className="absolute top-0 left-0 w-1 h-full bg-[#c8a45e]"></div>
                  <h3 className="font-display text-sm font-bold text-gray-400 uppercase tracking-widest mb-4">Sales Manager</h3>

                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 rounded-full bg-gray-100 border-2 border-[#c8a45e] flex items-center justify-center overflow-hidden">
                      <FaShieldAlt className="text-3xl text-gray-300" />
                    </div>
                    <div>
                      <h4 className="font-display text-lg font-bold text-[#0a0a0a]">Khushboo Advani</h4>
                      <p className="text-xs text-[#c8a45e] font-bold uppercase tracking-wider">BNW Developments</p>
                    </div>
                  </div>

                  <div className="space-y-4 mb-6">
                    <div className="flex items-center gap-3 text-gray-600 hover:text-[#0a0a0a] transition-colors">
                      <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center flex-shrink-0">
                        <FaPhone className="text-xs" />
                      </div>
                      <a href="tel:+971XXXXXXXXX" className="text-sm font-medium hover:underline decoration-[#c8a45e] decoration-2 underline-offset-4">+971 XXXXXXXXX</a>
                    </div>
                    <div className="flex items-center gap-3 text-gray-600 hover:text-[#0a0a0a] transition-colors">
                      <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center flex-shrink-0">
                        <FaEnvelope className="text-xs" />
                      </div>
                      <a href="mailto:sales@bnwdevelopments.com" className="text-sm font-medium hover:underline decoration-[#c8a45e] decoration-2 underline-offset-4 break-all">sales@bnwdevelopments.com</a>
                    </div>
                  </div>

                  <Link to="/contact" className="w-full block text-center py-3 border-2 border-[#0a0a0a] text-[#0a0a0a] font-display font-bold uppercase tracking-wider rounded-xl hover:bg-[#0a0a0a] hover:text-white transition-all duration-300">
                    Schedule Visit
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Overlay */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-xl flex items-center justify-center p-4 animate-fade-in"
          onClick={closeLightbox}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <button className="absolute top-6 right-6 text-white/50 hover:text-white transition-colors p-2" onClick={closeLightbox}>
            <FaTimes className="text-4xl" />
          </button>

          <button className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full border border-white/20 text-white items-center justify-center hover:bg-white hover:text-black transition-all" onClick={(e) => { e.stopPropagation(); prevImage(); }}>
            <FaChevronLeft />
          </button>

          <div className="relative w-full max-w-6xl max-h-[85vh] flex flex-col items-center justify-center" onClick={(e) => e.stopPropagation()}>
            {mediaItems[lightboxImage]?.type === 'video' ? (
              <video
                ref={lightboxVideoRef}
                className="w-full max-h-[70vh] object-contain rounded-lg shadow-2xl bg-black"
                autoPlay
                muted
                loop
                playsInline
                controls
                preload="auto"
                poster={mediaItems[lightboxImage].poster}
                onError={handleVideoError}
              >
                <source src={mediaItems[lightboxImage].src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={mediaItems[lightboxImage]?.src}
                alt={`Property view ${lightboxImage + 1}`}
                className="w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
              />
            )}

            <div className="mt-6 flex gap-3 overflow-x-auto max-w-full pb-2 px-4 custom-scrollbar">
              {mediaItems.map((item, index) => (
                <div
                  key={index}
                  className={`w-20 h-14 flex-shrink-0 rounded-md overflow-hidden cursor-pointer border-2 transition-all ${lightboxImage === index ? 'border-[#c8a45e] opacity-100 scale-105' : 'border-transparent opacity-50 hover:opacity-80'}`}
                  onClick={(e) => { e.stopPropagation(); setLightboxImage(index); }}
                >
                  <img src={item.type === 'video' ? item.poster || item.src : item.src} className="w-full h-full object-cover" alt="" />
                </div>
              ))}
            </div>

            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-4 px-4 py-1 bg-white/10 backdrop-blur-md rounded-full text-white/80 text-xs font-mono tracking-widest">
              {lightboxImage + 1} / {mediaItems.length}
            </div>
          </div>

          <button className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full border border-white/20 text-white items-center justify-center hover:bg-white hover:text-black transition-all" onClick={(e) => { e.stopPropagation(); nextImage(); }}>
            <FaChevronRight />
          </button>
        </div>
      )}

      {/* PDF Viewer Overlay */}
      {pdfViewerOpen && isImagePages && pdfPages && pdfPages.length > 0 && (
        <div
          className="fixed inset-0 z-[100] bg-[#1a1a1a] flex flex-col animate-fade-in"
          onClick={closePdfViewer}
        >
          {/* PDF Toolbar */}
          <div className="h-16 bg-[#0a0a0a] flex items-center justify-between px-6 border-b border-white/10" onClick={(e) => e.stopPropagation()}>
            <div className="text-white font-display text-sm uppercase tracking-wider">Brochure Viewer</div>

            <div className="flex items-center gap-4 text-white/70 font-mono text-sm">
              <button onClick={prevPdfPage} className="p-2 hover:text-white bg-white/5 rounded"><FaChevronLeft /></button>
              <span>Page {currentPdfPage + 1} / {pdfPages.length}</span>
              <button onClick={nextPdfPage} className="p-2 hover:text-white bg-white/5 rounded"><FaChevronRight /></button>
            </div>

            <button onClick={closePdfViewer} className="text-white/70 hover:text-white p-2">
              <FaTimes className="text-xl" />
            </button>
          </div>

          {/* PDF Content */}
          <div className="flex-1 flex overflow-hidden relative" onClick={(e) => e.stopPropagation()}>
            {/* Main Page View */}
            <div className="flex-1 flex items-center justify-center p-8 overflow-auto"
              onTouchStart={handlePdfTouchStart}
              onTouchMove={handlePdfTouchMove}
              onTouchEnd={handlePdfTouchEnd}
            >
              <img
                src={pdfPages[currentPdfPage]}
                alt={`Brochure page ${currentPdfPage + 1}`}
                className="max-h-full max-w-full shadow-2xl object-contain bg-white"
              />
            </div>

            {/* Thumbnail sidebar */}
            <div className="w-24 border-l border-white/10 bg-[#000] overflow-y-auto hidden md:flex flex-col gap-4 p-4">
              {pdfPages.map((page, index) => (
                <div
                  key={index}
                  className={`w-full aspect-[2/3] relative cursor-pointer opacity-60 hover:opacity-100 transition-opacity ${currentPdfPage === index ? '!opacity-100 ring-2 ring-[#c8a45e]' : ''}`}
                  onClick={(e) => { e.stopPropagation(); setCurrentPdfPage(index); }}
                >
                  <img src={page} className="w-full h-full object-cover bg-white" alt="" />
                  <div className="absolute bottom-0 right-0 bg-black/80 text-white text-[10px] px-1">{index + 1}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
